import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  copiedImg: 0,
  downloadViewport: 0,
  windowPreset: 0,
}

const copyImgSlice = createSlice({
  name: 'copyImgSlice',
  initialState,
  reducers: {
    toggleCopyFlag: (state): void => {
      state.copiedImg++;
    },
    resetCopyFlag: (state): void => {
      state.copiedImg = 0;
    },
    toggleDownloadViewportFlag: (state): void => {
      state.downloadViewport++;
    },
    resetDownloadViewportFlag: (state): void => {
      state.downloadViewport = 0;
    },
    toggleWindowPresetFlag: (state): void => {
      state.windowPreset++;
    },
    resetWindowPresetFlag: (state): void => {
      state.windowPreset = 0;
    },
  },
});

export const { toggleCopyFlag, toggleDownloadViewportFlag, toggleWindowPresetFlag, resetWindowPresetFlag, resetCopyFlag, resetDownloadViewportFlag } = copyImgSlice.actions;
export default copyImgSlice.reducer;
